export default __webpack_public_path__ + "static/bisball-871e65eee40537ed6d3bda421cbc1a6d.png";